import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {DrawSymbol} from '../_interface/symbol.model';

export const createSymbolForEditFromEvent = createAction(
	'[Symbol 🎁] Create symbol for edit from event',
	props<{ event: Event }>()
);

export const setSymbolForEdit = createAction(
	'[Symbol 🎁] Set symbol for edit',
	props<{ symbol: Partial<DrawSymbol> }>()
);

export const cancelSymbolForEdit = createAction(
	'[Symbol 🎁] Cancel symbol edit'
);

export const initLoadSymbols = createAction('[Symbol 🎁] Init Load Symbols');

export const loadSymbols = createAction(
	'[Symbol 🎁] Load Symbols',
	props<{ symbols: DrawSymbol[] }>()
);

export const addSymbol = createAction(
	'[Symbol 🎁] Add Symbol',
	props<{ symbol: DrawSymbol }>()
);

export const tryUpsertSymbol = createAction(
	'[Symbol 🎁] Try to upsert Symbol',
	props<{ symbol: Partial<DrawSymbol> }>()
);

export const tryDeleteSymbol = createAction(
	'[Symbol 🎁] Try to delete Symbol',
	props<{ symbolId: string }>()
);

export const createTemplateFieldAndSymbol = createAction(
	'[Symbol 🎁] Create template field and symbol',
	props<{ symbol: Partial<DrawSymbol> }>()
);

export const submitSymbol = createAction(
	'[Symbol 🎁] Submit Symbol',
	props<{ symbol: Partial<DrawSymbol> }>()
);

export const upsertSymbol = createAction(
	'[Symbol 🎁] Upsert Symbol',
	props<{ symbol: DrawSymbol }>()
);

export const addSymbols = createAction(
	'[Symbol 🎁] Add Symbols',
	props<{ symbols: DrawSymbol[] }>()
);

export const upsertSymbols = createAction(
	'[Symbol 🎁] Upsert Symbols',
	props<{ symbols: DrawSymbol[] }>()
);

export const updateSymbol = createAction(
	'[Symbol 🎁] Update Symbol',
	props<{ symbol: Update<DrawSymbol> }>()
);

export const updateSymbols = createAction(
	'[Symbol 🎁] Update Symbols',
	props<{ symbols: Update<DrawSymbol>[] }>()
);

export const deleteSymbol = createAction(
	'[Symbol 🎁] Delete Symbol',
	props<{ symbolId: string }>()
);

export const deleteSymbols = createAction(
	'[Symbol 🎁] Delete Symbols',
	props<{ ids: string[] }>()
);

export const clearSymbols = createAction(
	'[Symbol 🎁] Clear Symbols'
);
